<script>
    import {createEventDispatcher} from 'svelte';
    import {mobileSearch,groupRemoveMobile} from "./requests";
    import {memberDelete} from "./requests";
    import app_alert from "./stores/alerts";
    import success from './stores/success';
    import members from "./stores/members";
    import groups from "./stores/groups";

    export let showMobileSearch = false;
    export let mobile = '';

    let groupsList = [];
    let membersList = [];
    let initialized = false;

    const dispatch = createEventDispatcher();

    const Close = () => {
        showMobileSearch = false;
        initialized = false;
        mobile = '';
        groupsList = [];
        membersList = [];
        dispatch('close');
    }

    const search = async () => {
        if (!mobile.length) {
            app_alert.show('error', "Δεν έχετε πληκτρολογήσει τον αριθμό κινητού για αναζήτηση.");
            return;
        }

        initialized = true;

        const [err, res] = await mobileSearch(mobile);

        if (err) {
            return;
        }

        groupsList = res.groups;
        membersList = res.members;
    }

    const onkeyup = event => {
        if (event.key === 'Enter') {
            search();
        }
    }

    const onDeleteGroupMobile = group => {
        app_alert.show('confirm', `Να διαγραφεί το κινητό από την ομάδα ${group.name};`, () => {
            deleteGroupMobile(group.id);
        });
    }

    const deleteGroupMobile = async (group_id) => {
        const [err, res] = await groupRemoveMobile(group_id, mobile);

        if (err) {
            return;
        }

        if (!res) {
            app_alert.show('error', "Η ομάδα δεν βρέθηκε!");
            return;
        }

        groups.updateGroup(res);
        let group = groupsList.find(x => x.id === group_id);
        if (group) {
            group.number_removed = true;
        }
        groupsList = groupsList;

        success.show("Το κινητό αφαιρέθηκε από την ομάδα.");
    }

    const onEditMember = member => {
        members.editMember(member.id, memberChange);
    }
    const memberChange = () => {
        members.closeMember();
    }

    const onDeleteMember = member => {
        app_alert.show('confirm', `Να διαγραφεί η επαφή "${member.lname} ${member.fname}";`, () => { deleteMember(member) });
    }

    const deleteMember = async (member) => {
        const [err, res] = await memberDelete(member.id);
        if (err) {
            return;
        }
        members.deleteMember(member.id);
        success.show("Η επαφή διαγράφτηκε.");

        membersList = membersList.filter(x => x.id !== member.id);

        // remove member from groups total phones
        member.in_groups.map(group_id => {
            let group = $groups.list.find( x=> x.id === group_id);
            if (group.total_mobiles > 0) {
                group.total_mobiles--;
            }
        });
        $groups.list = $groups.list;
    }

    $:{
        if (!initialized && mobile.length) {
            search();
        }
    }
</script>

<div class="popup-overlay" class:visible={ showMobileSearch }>
    <div class="modal modal-xs">
        <div class="modal-header">
            <div class="modal-title">
                Εύρεση αριθμού
            </div>
            <div class="controls-right">
                <span on:click="{ Close }"><i class="fa fa-times"></i></span>
            </div>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group">
                        <label>Αριθμός κινητου</label>
                        <input type="text" class="form-control" bind:value="{ mobile }" on:keyup="{ onkeyup }">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <button class="btn btn-primary btn-block" on:click="{ search }">Εύρεση</button>
                    </div>
                </div>
            </div>

            {#if groupsList.length || membersList.length}
                <hr>
                <table class="table table-bordered table-list table-data mrg-b-none">
                    <thead>
                        <tr>
                            <th colspan="2">Αποτελέσματα αναζήτησης</th>
                        </tr>
                    </thead>
                    <tbody>
                    {#each groupsList as group}
                        <tr class="pointer">
                            <td><i class="fa fa-users"></i> { group.name }</td>
                            {#if !group.number_removed}
                                <td class="row-actions">
                                    <span title="Αφαίρεση κινητού από την ομάδα" on:click="{ () => onDeleteGroupMobile(group) }">
                                        <i class="fa fa-minus"></i>
                                    </span>
                                </td>
                            {:else}
                                <td class="text-right">
                                    <i class="fa fa-check"></i>
                                </td>
                            {/if}
                        </tr>
                    {/each}
                    {#each membersList as member}
                        <tr class="pointer">
                            <td><i class="fa fa-address-card-o"></i> { member.lname } { member.fname }</td>
                            <td class="row-actions">
                                <span title="Διόρθωση επαφής" on:click="{ () => { onEditMember(member) } }">
                                    <i class="fa fa-edit"></i>
                                </span>
                                <span title="Διαγραφή επαφής" on:click="{ () => onDeleteMember(member) }">
                                    <i class="fa fa-remove"></i>
                                </span>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {:else if initialized}
                <hr>
                <div class="alert alert-info">
                    Δεν βρέθηκαν ομάδες ή επαφές με αυτό το κινητό.
                </div>
            {/if}
        </div>
        <div class="modal-footer text-right">
            <button class="btn btn-default" on:click="{ Close }">Κλείσιμο</button>
        </div>
    </div>
</div>